import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toArray, isEmpty, isNull } from 'lodash';

import { formatNumber } from '../../../utils';
import { PATH } from '../../../constants/path';
import { BRAND_NAME } from '../../../constants';
import { withTemplate } from '../../template/withTemplate';
import HowItWorksComponent from '../../HowItWorksComponent';
import FaqElementComponent from '../faq/FaqElementComponent';
import { hasCashback } from '../../../services/partner/utils';
import { fetchFaqIfNeeded } from '../../../services/faq/actions';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import CustomerServiceComponent from '../../CustomerServiceComponent';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { HeadComponent } from '../../HeadComponent';

import './HowItWorksPage.scss';

export class HowItWorksPage extends React.Component {
    componentDidMount() {
        this.props.fetchFaqIfNeeded();
    }

    render() {
        const { i18nPage, faqData, partnersCount, i18nCustomerService, locale } = this.props;

        // Currently select the first theme with non empty faq list /!\
        const theme = faqData.find(e => !isEmpty(e.faqs)) || null;

        return (
            <main className="conteneur conteneur-mobile" id="p-cmt-ca-marche">
                <HeadComponent title={i18nPage.TITLE} description={i18nPage.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.HOW_IT_WORK_PATH}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18nPage.H1}</h1>

                <div>
                    <h3>{convertHtmlToReactDomWithParams(i18nPage.H31, BRAND_NAME)}</h3>
                    <p>
                        {convertHtmlToReactDomWithParams(
                            i18nPage.TEXT1,
                            BRAND_NAME,
                            formatNumber(partnersCount, locale)
                        )}
                    </p>

                    <h3>{i18nPage.H32}</h3>
                    <p>{convertHtmlToReactDomWithParams(i18nPage.TEXT2, BRAND_NAME)}</p>
                </div>

                <HowItWorksComponent />

                <div className="help-container grid">
                    <div className="faq-container inbl">
                        <div className="faq-bandeau">{i18nPage.QUESTION}</div>
                        <div className="faq-list-container">
                            {!isNull(theme) &&
                                theme.faqs
                                    .slice(0, 4)
                                    .map(faq => (
                                        <FaqElementComponent
                                            key={faq.id}
                                            faq={faq}
                                            cssClass="question-comment-ca-marche-page"
                                            forceArrowRight
                                            linkToFaqPage
                                        />
                                    ))}
                        </div>
                    </div>
                    <CustomerServiceComponent i18n={i18nCustomerService} />
                </div>
            </main>
        );
    }
}

HowItWorksPage.propTypes = {
    partnersCount: PropTypes.number.isRequired,
    i18nPage: PropTypes.object.isRequired,
    i18nCustomerService: PropTypes.object.isRequired,
    faqData: PropTypes.array
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        locale: state.i18n.locale,
        partnersCount: toArray(state.partner.partners).filter(partner => hasCashback(partner))
            .length,
        i18nPage: state.i18n.page.HOW_IT_WORKS,
        i18nCustomerService: state.i18n.feature.aide.serviceclient,
        faqData: state.faq.faqs || []
    };
};

const mapDispatchToProps = {
    fetchFaqIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(HowItWorksPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/howitworks/HowItWorksPage.js